import { matchPath } from 'react-router'

import config from 'constants/config'
import { useAppSelector } from 'hooks/reduxHooks'

const tripPlannerPath = '/:regionCode/trip-planner'

export function shouldShowTripPlannerSaveEntryPoints(
  pathname = '',
  enableTripPlannerSaveEntryPoints = config.ENABLE_TRIP_PLANNER_SAVE_ENTRY_POINTS,
  enableTripPlanner = config.ENABLE_TRIP_PLANNER,
) {
  const isSaveEntryPointsEnabled =
    enableTripPlannerSaveEntryPoints ?? enableTripPlanner

  return (
    !!isSaveEntryPointsEnabled ||
    !!matchPath(pathname, { path: tripPlannerPath, exact: false })
  )
}

function useShouldShowTripPlannerSaveEntryPoints() {
  const pathname = useAppSelector((state) => state.router.location.pathname)

  return shouldShowTripPlannerSaveEntryPoints(
    pathname,
    config.ENABLE_TRIP_PLANNER_SAVE_ENTRY_POINTS,
    config.ENABLE_TRIP_PLANNER,
  )
}

export default useShouldShowTripPlannerSaveEntryPoints
